import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as types from '../../actions/actionTypes';
import {
    siteSearchBlurred, siteSearchChanged, siteSearchFocused,
} from '../../actions/uiActions';
import { getMessage } from '../../reducers/i18n';

import { getCurrentSearchValue } from '../../reducers/ui.sitesearch';
import Icon from '../Icon';
import SearchLayout from '../styles/ExpandableSearch';
import SearchInput from '../styles/SearchInput';
import SearchIcon from './SearchIcon';


class ExpandableSiteSearch extends React.Component {

    state = {
        searchValue: this.props.initialSearchValue,
        expanded: false,
    };

    // Trigger the search action on key enter.
    onKeyDown = e => {
        if (e.keyCode === 13) {
            this.props.setSearchValue(this.state.searchValue);
            this.props.triggerSearch(this.state.searchValue);
        }
    };

    handleInput = e => {
        this.setState(
            Object.assign({}, this.state, {searchValue: e.target.value}));
    };

    handleClose = () => {
        this.setState(Object.assign({}, this.state, {expanded: false}));
    };

    handleOpen = () => {
        this.setState(Object.assign({}, this.state, {expanded: true}));
    };

    render () {
        return (
            <React.Fragment>

                <SearchLayout expanded={this.state.expanded}
                              onKeyDown={this.onKeyDown}>
                    <SearchInput
                        classes={{
                            input: 'stolo-site-search',
                            root: 'stolo-site-searchroot',
                        }}
                        placeholder={this.props.placeholder}
                        type='search'
                        value={this.state.searchValue}
                        onFocus={this.props.inputActions.siteSearchFocused}
                        onBlur={this.props.inputActions.siteSearchBlurred}
                        onChange={this.handleInput}
                        disableUnderline
                        name='site-search'
                    />
                    <IconButton
                        color='inherit'
                        aria-label='open drawer'
                        onClick={this.handleClose}
                        className='schnoffle-button-dense'
                    >
                        <Icon
                            name='icon-close'
                            height='1.7rem'
                            width='1.7rem'
                            iconColor='common.lightBlack'
                        />
                    </IconButton>
                </SearchLayout>
                <SearchIcon handleClick={this.handleOpen}
                            expanded={this.state.expanded} />
            </React.Fragment>
        );
    }
}


const mapDispatch = dispatch => (
    {
        triggerSearch: search => dispatch({
            type: types.NAVIGATED_TO_SEARCHGALLERY,
            meta: {query: {q: search}},
        }),
        setSearchValue: search => dispatch(siteSearchChanged(search)),
        inputActions: bindActionCreators({
            siteSearchBlurred,
            siteSearchFocused,
        }, dispatch),
    }
);

const mapState = state => (
    {
        initialSearchValue: getCurrentSearchValue(state),
        placeholder: getMessage(state, 'SEARCH_INPUT_PLACEHOLDER'),
    }
);

export default connect(mapState, mapDispatch)(ExpandableSiteSearch);



// WEBPACK FOOTER //
// ./src/components/header/ExpandableSiteSearch.js